<template>
  <form @submit.prevent="submit">
    <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 5 из 6</span></h2>
    <h3 class="form__subtitle">Опрос</h3>

    <div class="form-row form-row_no-flex">
      <p class="form-row__description">Какую марку сигарет вы покупали и&nbsp;курили чаще всего в&nbsp;течение последних 4&#8209;х&nbsp;недель?</p>

      <custom-select
        label="Выберите бренд"
        label-filled="Бренд"
        v-model="$v.form.primaryCigaretteBrand.$model"
        :options="cigaretteMarksOptions"
        :error="$v.form.primaryCigaretteBrand.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.primaryCigaretteBrand.$error">
            <div v-if="!$v.form.primaryCigaretteBrand.required">Заполните поле</div>
          </div>
        </template>
      </custom-select>

      <custom-select
        v-if="form.primaryCigaretteBrand && getSubfamilyOptions(form.primaryCigaretteBrand)"
        label="Выберите марку"
        label-filled="Марка"
        v-model="form.primarySubfamily"
        :options="getSubfamilyOptions(form.primaryCigaretteBrand)"
        :error="$v.form.primarySubfamily.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.primarySubfamily.$error">
            <div v-if="!$v.form.primarySubfamily.required">Заполните поле</div>
          </div>
        </template>
      </custom-select>

      <p class="form-row__description">Если вашей основной марки нет в&nbsp;продаже, какую марку вы купите?</p>

      <custom-select
        label="Выберите бренд"
        label-filled="Бренд"
        v-model="$v.form.secondaryCigaretteBrand.$model"
        :options="cigaretteMarksOptions"
        :error="$v.form.secondaryCigaretteBrand.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.secondaryCigaretteBrand.$error">
            <div v-if="!$v.form.secondaryCigaretteBrand.required">Заполните поле</div>
          </div>
        </template>
      </custom-select>

      <custom-select
        v-if="form.secondaryCigaretteBrand && getSubfamilyOptions(form.secondaryCigaretteBrand)"
        label="Выберите марку"
        label-filled="Марка"
        v-model="form.secondarySubfamily"
        :options="getSubfamilyOptions(form.secondaryCigaretteBrand)"
        :error="$v.form.secondarySubfamily.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.secondarySubfamily.$error">
            <div v-if="!$v.form.secondarySubfamily.required">Заполните поле</div>
          </div>
        </template>
      </custom-select>

    </div>

    <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
      <template #errors>
        <div class="text-input__error">
          <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
        </div>
      </template>
    </smart-captcha>

    <div class="form-row form-row_mobile-wrap">
      <div class="form__nav">
        <!--
        <router-link v-if="!$store.state.currentUser" :to="{name: 'login'}" class="form__link">Войти</router-link>
        <router-link :to="{ name: 'feedback' }" class="form__link">Написать нам</router-link>
        -->
        <delete-questionnaire-btn />
      </div>
      <button class="form__submit button button__lg button__blue" type="submit">Продолжить</button>
    </div>
  </form>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import api from '../services/api';
  import CustomSelect from "./CustomSelect";
  import SmartCaptcha from "./SmartCaptcha.vue";
  import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

  export default {
  name: "SignUpStepSurvey",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    CustomSelect,
  },
  data() {
    return {
      cigaretteMarks: [],
      form: {
        primaryCigaretteBrand: '',
        primarySubfamily: '',
        secondaryCigaretteBrand: '',
        secondarySubfamily: '',
        captcha: ''
      },
    };
  },
  computed: {
    cigaretteMarksOptions() {
      return [
        ...this.cigaretteMarks.map(item => ({value: item.spicId, name: item.name}))
      ];
    },
    subfamilyOptions() {
      if (this.form.primaryCigaretteBrand) {
        const list = this.cigaretteMarks.filter(item => (item.spicId === this.form.primaryCigaretteBrand))[0];
        if (typeof list.subfamilies !== 'undefined') {
          return [
            ...list.subfamilies.map(item => ({value: item.spicId, name: item.name}))
          ]
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  validations: {
    form: {
      primaryCigaretteBrand: {required},
      primarySubfamily: {required},
      secondaryCigaretteBrand: {required},
      secondarySubfamily: {required},
      captcha: {required}
    },
  },
  created() {
    this.fetchCigaretteMarks();
  },
  watch: {
    'form.primaryCigaretteBrand'() {
      this.form.primarySubfamily = '';
    }
  },
  methods: {
    getSubfamilyOptions(cigaretteFamily) {
      if (cigaretteFamily) {
        const list = this.cigaretteMarks.filter(item => (item.spicId === cigaretteFamily))[0];
        if (typeof list.subfamilies !== 'undefined') {
          return [
            ...list.subfamilies.map(item => ({value: item.spicId, name: item.name}))
          ]
        } else {
          return false
        }
      } else {
        return false
      }
    },
    async fetchCigaretteMarks() {
      this.cigaretteMarks = await api.fetchCigaretteMarks();
    },
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          const result = await api.registerStepSurvey(this.form);

          if (result) {
            this.$emit('complete');
            this.$store.dispatch('hideErrorsBag');
          }
        } catch (e) {
          this.$store.dispatch('setErrors', e);

        } finally {
          this.$store.dispatch('hideLoader');
        }
      }
    },
  },
}
</script>
